import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { DrawerV2, Notification } from '@nxt-costco-com/forge-components';
import { Alert } from '@nxt-costco-com/forge-icons';
import { AppActionTypes } from 'src/types';
import { BODY_SX, DEFAULT_HEADER_PROPS, DRAWER_BODY_SX, DRAWER_SX, ERROR_SX } from 'src/components/CookieSettings/SettingsDrawer/constants';
import type { ErrorDrawerProps } from './types';

export const ErrorDrawer: FC<ErrorDrawerProps> = ({ open, dispatch }: ErrorDrawerProps) => {
    const { t } = useTranslation();

    const drawerHeaderProps = {
        ...DEFAULT_HEADER_PROPS,
        title: t('title'),
        closeButtonAriaLabel: t('closeButtonAriaLabel'),
        onClose: () => {
            dispatch({ type: AppActionTypes.CLOSE_DRAWER });
        },
        headerSx: {},
    }

    return (
        <DrawerV2
            anchor="right"
            open={open}
            headerProps={ drawerHeaderProps }
            aria-label={t('title')}
            bodySx={DRAWER_BODY_SX}
            sx={DRAWER_SX}  // To bring the drawer above the WCS Costco menu
        >
            <Box
                sx={ BODY_SX }
            >
                <Box sx={ERROR_SX}>
                    <Notification
                        message={t('errorMessages.setTrackingConsentDetailsFailed')}
                        severity="critical"
                        icon={<Alert />}
                    />
                </Box>
            </Box>
        </DrawerV2>
    );
};
